export default {
    computed: {
        /**
         * Options for the TinyMCE WYSIWYG
         *
         * @return {Object}
         */
        wysiwygOptions() {
            return {
                statusbar: false,
                menubar: false,
                height: 300,
                images_upload_url: route('content.image'),
            }
        },
        /**
         * Plugin options for the TinyMCE WYSIWYG
         *
         * @return {Array}
         */
        wysiwygPlugins() {
            return [
                'advlist autolink lists link image charmap preview anchor textcolor',
                'searchreplace visualblocks code fullscreen insertdatetime media table',
                'contextmenu paste code directionality template colorpicker textpattern',
            ]
        },
    },
}
